<template>
  <div class="print-wrapper">
    <div class="printable-area">
      <slot />
    </div>
    <button @click="print()">
      Print
      <font-awesome-icon prefix :icon="['fas', 'print']" size="2x" />
    </button>
  </div>
</template>

<script>
export default {
  mounted () {
  },

  methods: {
    print () {
      window.print()
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

@page {
  size: letter portrait;
  margin: 0;
}

body {
  margin: 0;
}

@media print {
  .print-wrapper > :not(.printable-area) {
    display: none;
  }
}

.print-wrapper {
  @include body-font;
  background-color: $white;
  font-size: 14px;
  color: $dark-shades;
  margin: 0;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;

  .printable-area {
    size: letter portrait;
    width: 8.5in;
    margin: auto;
  }

  h2 {
    text-align: left;
    &::after {
      content: none;
    }
  }

  button {
    position: fixed;
    bottom: 15px;
    right: 30px;
    z-index: 100;
    border: none;
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    background: none;
    cursor: pointer;
    padding: 20px 60px;
    display: inline-block;
    margin: 15px 30px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
    outline: none;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    padding: 20px 100px 20px 20px;
    overflow: hidden;
    background-color: $dark-shades;
    color: $light-shades;

    svg, i {
      right: 10px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 5;
    }

    &::after {
      content: '';
      position: absolute;
      z-index: -1;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
      transition: all 0.3s;
      width: 70px;
      height: 200%;
      background: rgba(255,255,255,0.1);
      z-index: 1;
      right: 0;
      top: 0;
      margin: -5px 0 0 -5px;
      -webkit-transform-origin: 0 0;
      -webkit-transform: rotate(-20deg);
      -moz-transform-origin: 0 0;
      -moz-transform: rotate(-20deg);
      -ms-transform-origin: 0 0;
      -ms-transform: rotate(-20deg);
      transform-origin: 0 0;
      transform: rotate(-20deg);
    }

    &:hover {
      background-color: $main;
      &::after {
        width: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Print.vue